export { default } from './EmergencyContacts';
